import type { SiteSeparation as SiteSeparationSettings } from '@ipfabric/utils/schema/siteSeparation/siteSeparation';

export const getSiteSeparationWithDefaults = (
  siteSeparation: SiteSeparationSettings | undefined,
): SiteSeparationSettings => ({
  manualEnabled: siteSeparation?.manualEnabled ?? true,
  neighborshipFallbackEnabled:
    siteSeparation?.neighborshipFallbackEnabled ?? true,
  rules: siteSeparation?.rules ?? [],
});
